<script setup>
import { RouterView } from 'vue-router'
import { useAuthStore } from '@/stores/auth_store'
const auth = useAuthStore()

auth.testToken()
</script>

<template>
  <RouterView />
</template>
